import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import cn from 'classnames';
import { Box, Column, Drawer, DropdownMenu, DropdownMenuItem, Row, Typography } from 'seagull';
import { ChevronDown, ChevronUp } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { TimeActivityActions } from '../TimeActivityActions/TimeActivityActions';
import { TimeActivityCard } from '../TimeActivityCard/TimeActivityCard';
import styles from './TimeActivitiesDrawer.module.scss';
export const GetTimeActivitiesDrawerTID = (parentTestId)=>getTestIds(parentTestId);
export const TimeActivitiesDrawer = (param)=>{
    let { open, serviceOptions, selectedService, unusedTimeActivities, accountingName, isSelectedServiceMapped, showAddAll, isRefreshing, mapServiceSlot, onSelectService, onAddSingle, onAddAll, onRefresh, onClose, bi, testId } = param;
    const { t } = useLocaleKeys('components.billClientModal.timeActivities');
    const { TimeActivitiesDrawerTestIds } = useMemo(()=>GetTimeActivitiesDrawerTID(testId), [
        testId
    ]);
    const [servicesSelectorOpen, setServicesSelectorOpen] = useState(false);
    return /*#__PURE__*/ _jsx(Drawer, {
        bi: bi.drawer,
        PaperProps: {
            style: {
                position: 'absolute',
                width: 680
            }
        },
        variant: "persistent",
        open: open,
        headerClassName: styles.drawerHeader,
        header: /*#__PURE__*/ _jsxs(Column, {
            justifyContent: "center",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h6",
                    weight: "normal",
                    children: t.header()
                }),
                /*#__PURE__*/ _jsx(DropdownMenu, {
                    hAlign: "left",
                    maxHeight: 200,
                    onOpenChange: setServicesSelectorOpen,
                    target: /*#__PURE__*/ _jsxs(Row, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                weight: "normal",
                                ellipsis: true,
                                skin: "primary",
                                className: styles.timeActivitiesServiceName,
                                testId: TimeActivitiesDrawerTestIds.ServiceName(),
                                children: selectedService.name
                            }),
                            servicesSelectorOpen ? /*#__PURE__*/ _jsx(ChevronUp, {
                                size: 20,
                                className: styles.arrowIcon
                            }) : /*#__PURE__*/ _jsx(ChevronDown, {
                                size: 20,
                                className: cn(styles.arrowIcon, styles.arrowIconDown)
                            })
                        ]
                    }),
                    children: serviceOptions.map((param)=>{
                        let { id, name, costString } = param;
                        return /*#__PURE__*/ _jsxs(DropdownMenuItem, {
                            bi: bi.serviceOption,
                            height: 56,
                            testId: TimeActivitiesDrawerTestIds.ServiceOption(id),
                            onClick: ()=>onSelectService({
                                    id,
                                    name,
                                    costString
                                }),
                            selected: selectedService.id === id,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    ellipsis: true,
                                    variant: "paragraph1",
                                    children: name
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    ellipsis: true,
                                    variant: "paragraph1",
                                    skin: "secondary",
                                    children: costString
                                })
                            ]
                        }, id);
                    })
                })
            ]
        }),
        onClose: onClose,
        onCloseButtonClick: onClose,
        BackdropProps: {
            invisible: true
        },
        children: /*#__PURE__*/ _jsxs(Column, {
            testId: TimeActivitiesDrawerTestIds.Root(),
            children: [
                /*#__PURE__*/ _jsx(TimeActivityActions, {
                    showAddAll: showAddAll,
                    isRefreshing: isRefreshing,
                    onAddAll: onAddAll,
                    onRefresh: onRefresh,
                    bi: bi.actions,
                    testId: TimeActivitiesDrawerTestIds.Actions()
                }),
                isSelectedServiceMapped ? unusedTimeActivities.length ? unusedTimeActivities.map((timeActivity)=>/*#__PURE__*/ _jsx(TimeActivityCard, {
                        timeActivity: timeActivity,
                        accountingName: accountingName,
                        onAdd: ()=>onAddSingle(timeActivity),
                        bi: bi.card,
                        testId: TimeActivitiesDrawerTestIds.Card(timeActivity.id)
                    }, timeActivity.id)) : /*#__PURE__*/ _jsx(Box, {
                    className: styles.timeActivitiesEmptyState,
                    children: /*#__PURE__*/ _jsx(Typography, {
                        testId: TimeActivitiesDrawerTestIds.EmptyState(),
                        variant: "paragraph1",
                        skin: "secondary",
                        children: t.emptyState({
                            accountingName
                        })
                    })
                }) : /*#__PURE__*/ _jsx(Box, {
                    className: styles.timeActivitiesEmptyState,
                    children: /*#__PURE__*/ _jsxs(Typography, {
                        testId: TimeActivitiesDrawerTestIds.EmptyState(),
                        variant: "paragraph1",
                        skin: "secondary",
                        children: [
                            t.notMapped({
                                accountingName
                            }),
                            mapServiceSlot
                        ]
                    })
                })
            ]
        })
    });
};
